module.exports = __webpack_public_path__ + "static/banner-c02d7e7d6ff1e4fca091b26f39301bfe.png";